import { Injectable } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import {
  TEMP_TOKEN,
  REGISTRATION_COMPLETE,
  GUEST_CART_ID,
  GUEST_ID,
  TOKEN,
  USER_ID,
} from '../constants/constant';
import { StateService } from './state.service';
import { StorageService } from './storage.service';
import { SignUpComponent } from '../components/sign-up/sign-up.component';
import { SigninmodalComponent } from '../components/signinmodal/signinmodal.component';

@Injectable({
  providedIn: 'root',
})
export class SignInModalService {
  constructor(
    private localStorageService: StorageService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private router: Router,
    private stateService: StateService,
    private activatedRoute: ActivatedRoute,
  ) { }

  open(isCheckout: boolean) {
    const modalRef = this.modalService.open(SigninmodalComponent, {
      keyboard: false,
    });
    modalRef.result.then((res: any) => {
      this.clearQueryParam()
      if (res?.token) {
        if (!res.regularUser && !res.registrationComplete) {
          this.localStorageService.setItem(TEMP_TOKEN, res.token);
          this.localStorageService.setItem(REGISTRATION_COMPLETE, 'false');
          const signUpModalRef = this.modalService.open(SignUpComponent);
          signUpModalRef.componentInstance.isCheckout = isCheckout
        }
        else if (res.regularUser && res.registrationComplete) {
          this.toastr.success(res.message);
          this.localStorageService.removeItem(GUEST_CART_ID);
          this.localStorageService.removeItem(GUEST_ID);
          this.localStorageService.removeItem(TEMP_TOKEN);
          this.localStorageService.setItem(TOKEN, res.token);
          this.localStorageService.setItem(USER_ID, res.userId.toString());
          this.localStorageService.setItem(REGISTRATION_COMPLETE, 'true');
          this.stateService.isTokenFetch(true);
          if (isCheckout) this.router.navigate(['account', 'checkout']);
        }
      } else {
        this.toastr.info(res.message);
      }
    }).catch(() => {
      this.clearQueryParam()
    });
  }

  clearQueryParam() {
    const queryParams: Params = { signIn: null, checkout: null };
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: queryParams,
      queryParamsHandling: 'merge',
    });
  }
}
